import { useMutation, useQueryClient } from "@tanstack/react-query";
import axiosInstance from "../../../api";
import FileActions from "../../FileActions";
import { useOktaAuth } from "@okta/okta-react";
import toastMessages from "../../helpers/toastMessage";

function useDeleteSignature({ closePopup }: { closePopup?: Function }) {
  const authState = useOktaAuth()?.authState;
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["deleteSignature"],
    mutationFn: async () => {
      return axiosInstance.patch(`v1/esignature/my-esignature`, undefined, {
        headers: {
          Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
        },
      });
    },
    onSuccess: (response) => {
      queryClient.refetchQueries({
        queryKey: ["physicianSignature"],
      });
      queryClient.refetchQueries({
        queryKey: ["profile"],
      });
      toastMessages.success(
        response?.data?.message ?? "E-signature deleted successfully"
      );
      closePopup?.();
    },
    onError: (error: any) => {
      const msg = error?.response?.data?.message ?? error?.message;
      toastMessages.error(msg);
      closePopup?.();
    },
  });
}

export default useDeleteSignature;
